import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import Link from '@mui/material/Link';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';

import FormControlLabel from '@explorer/components/ui/filter-form-control-label';
import {IMAGERY_CAPABILITIES} from '@explorer/constants/asset-types';

const SpectralBandsFilter = ({selected, onChange, disabled}) => {
  const {t} = useTranslation();

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography component="span">
          {t('filters.groupLabelSpectralBands')}
        </Typography>

        <Link
          color="inherit"
          underline="always"
          variant="caption"
          href="https://developers.planet.com/docs/data/psscene/"
          target="_blank"
          rel="noreferrer noopener"
        >
          {t('filters.linkDocsPssceneSpectralBands')}
        </Link>
      </Box>
      <Typography variant="caption">
        {t('filters.groupDetailsSpectralBands')}
      </Typography>
      <FormGroup style={{marginLeft: 4}}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              name={IMAGERY_CAPABILITIES.nir}
              checked={selected.includes(IMAGERY_CAPABILITIES.nir)}
              onChange={onChange}
            />
          }
          label={t('filters.fieldLabelNir')}
          disabled={disabled}
        />
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              name={IMAGERY_CAPABILITIES.multispectral}
              checked={selected.includes(IMAGERY_CAPABILITIES.multispectral)}
              onChange={onChange}
            />
          }
          label={t('filters.fieldLabelMultiBand')}
          disabled={disabled}
        />
      </FormGroup>
    </Box>
  );
};

SpectralBandsFilter.propTypes = {
  selected: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default SpectralBandsFilter;
